import React, { Component } from 'react';
import BuildingsFilterComponent from './components/BuildingsFilterComponent';
import EsriMapComponent from './components/EsriMap';
import './App.css';

class App extends Component {

  render() {
    return (<div><EsriMapComponent /></div>)
    // return (<div><BuildingsFilterComponent /></div>)
  }

  componentDidMount() {
    window.globalESRIoption = {url: 'https://js.arcgis.com/4.3/'};
    window.globalBuildingsURL =
      "https://services5.arcgis.com/Oos4pNA2538iVFA1/arcgis/rest/services/LPC_HistoricBuildings_Service/FeatureServer/0";
    if(window._widgetManager)
      window.globalMap = window._widgetManager.map;
  }
}
export default App;

//https://nyclpc.maps.arcgis.com/home/item.html?id=fa1bcaad31374a88839da3f0166e640a
